import resolve from "../../../../common/utils/object/resolve.js"

/*
 * Fill a route template's ${field} tokens from a record.
 *
 * Its own module, away from DisplayLink's JSX, because this is the only part of a
 * drill-through with a decision in it and it is worth testing on its own.
 *
 * Named tokens, not positional ones like `merge`'s '${1}'. A merge template is
 * translated and its word order belongs to a translator; a path is neither.
 */
const TOKEN = /\$\{([^}]+)\}/g

/**
 * The template with its tokens filled in, or **null when any of them resolves to
 * nothing**.
 *
 * Refusing is the whole point. A half-filled path is a route to the wrong page —
 * '/sales/invoice/' lands on the invoice list, which looks like it worked — and
 * the cases that produce one are ordinary: a journal posted before its ruleset
 * recorded a navigable id names its source document without being able to locate
 * it. The caller shows unlinked text instead.
 */
export const fillPath = (template, data) => {
    if (typeof template !== 'string') return null

    let complete = true
    const path = template.replace(TOKEN, (_, field) => {
        const value = resolve(field, data)
        if (value === null || value === undefined || value === '') {
            complete = false
            return ''
        }
        return encodeURIComponent(value)
    })
    return complete ? path : null
}

export default fillPath
